enum RecipientsWizardActionType {
    RECIPIENTS_WIZARD_SELECT_TAB = "RECIPIENTS_WIZARD_SELECT_TAB",
}

export default RecipientsWizardActionType;